import * as React from "react";
import "./boxed.scss";

interface IProps {
	style?: React.CSSProperties;
}

export const Boxed: React.SFC<IProps> = (props) => {
	return (
		<div className={"c-boxed"} style={props.style}>{props.children}</div>
	);
};
